export const EXPENSE_CATEGORIES = [
  'snacks',
  'toys', 
  'games',
  'clothes',
  'school',
  'other'
];

export const INCOME_SUBTYPES = [
  'allowance',
  'chore',
  'gift',
  'bonus'
];

export const AVATARS = [
  '🧒', '👧', '👦', '😊', '😎', '🤓', '🥳', '😇',
  '🦸', '🦸‍♀️', '🧙', '🧙‍♀️', '🥷', '👨‍🚀', '👩‍🚀'
];

export const KID_AVATARS = [
  ...AVATARS,
  '🐶', '🐱', '🐼', '🦊', '🦁', '🐯', '🐸', '🦄',
  '⚽', '🏀', '🎾', '🎵', '📚', '🚲', '🏊'
];

export const TRANSACTION_STATUS = {
  APPROVED: 'approved',
  PENDING: 'pending', 
  REJECTED: 'rejected'
};

export const CHORE_CLAIM_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};
